// extracted by mini-css-extract-plugin
module.exports = {"typeNumber":"input_typeNumber__NW15B"};